import { useEffect, useState } from 'react';
import { debounce, DEFAULT_DEBOUNCE_DELAY } from '@client/common/utils/debounce';

export type UseWindowScrollReturnType = {
  x: number;
  y: number;
};

export const useWindowScroll = (debounceTime = DEFAULT_DEBOUNCE_DELAY): UseWindowScrollReturnType => {
  const isBrowser = typeof window !== 'undefined';
  const [scroll, setScroll] = useState({
    x: 0,
    y: 0,
  });
  const handleScroll = debounce(() => {
    setScroll({
      x: window?.scrollX,
      y: window?.scrollY,
    });
  }, debounceTime);

  useEffect(() => {
    if (isBrowser) {
      handleScroll();

      window?.addEventListener('scroll', handleScroll);

      return (): void => {
        window?.removeEventListener('scroll', handleScroll);
      };
    }
  }, [isBrowser]);

  return scroll;
};
